module.exports = __webpack_public_path__ + "static/img/p12.ca24521.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p12.png
// module id = 237
// module chunks = 1